import { TbShoppingCartDiscount, TbMoneybag } from "react-icons/tb";
import { SiMoneygram } from "react-icons/si";
import { GiClothes } from "react-icons/gi";
import { MdPointOfSale } from "react-icons/md";
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardIcon from '../../components/Card/CardIcon.js';
import { EncabezadoContainer } from './cuentasComponents';
import { styles } from './cuentasComponents';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';


const useStyles = makeStyles(styles);

export function EncabezadoCuentaCorriente({ accountData, userSelection }) {
  const classes = useStyles();
  const { encabezadoVentas, encabezadocomprasORetiros, encabezadoDevoluciones, encabezadoStock, saldoCredito, saldoEfectivo, saldoNotaCredito,totalNotasDeCredito, pagadoConNotaCredito } = accountData
  return (
    <EncabezadoContainer>
      <Card>
        <CardHeader color='success' stats icon>
          <CardIcon color='success'>
            <MdPointOfSale />
          </CardIcon>
          <p className={classes.cardCategory}>Ventas</p>
          <h4 className={classes.cardTitle}>Cantidad {(encabezadoVentas?.total || 0).toFixed(2)}</h4>
          <h4 className={classes.cardTitle}>Ganancias ${(encabezadoVentas?.ganancia || 0).toFixed(2)}</h4>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader color='info' stats icon>
          <CardIcon color='info'>
            <TbShoppingCartDiscount />
          </CardIcon>
          <p className={classes.cardCategory}>{userSelection?.preferenciaPago === "CREDITO" ? "Compras" : "Retiros"}</p>

          <h4 className={classes.cardTitle}>Cantidad {(encabezadocomprasORetiros?.total || 0).toFixed(2)}</h4>
          <h4 className={classes.cardTitle}>Total ${(encabezadocomprasORetiros?.gasto || 0).toFixed(2)}</h4>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='warning' stats icon>
          <CardIcon color='warning'>
            <SiMoneygram />
          </CardIcon>
          <p className={classes.cardCategory}>Devolucion</p>

          <h4 className={classes.cardTitle}>Cantidad {(encabezadoDevoluciones?.total || 0).toFixed(2)}</h4>
          <h4 className={classes.cardTitle}>Total ${(encabezadoDevoluciones?.montoDescontado || 0).toFixed(2)}</h4>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='danger' stats icon>
          <CardIcon color='danger'>
            <TbMoneybag />
          </CardIcon>
          <p className={classes.cardCategory}>Notas de credito</p>
          <h4 className={classes.cardTitle}>N.C. generadas ${(totalNotasDeCredito || 0).toFixed(2)}</h4>
          <h4 className={classes.cardTitle}>N.C. usadas ${(pagadoConNotaCredito || 0).toFixed(2)}</h4>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='primary' stats icon>
          <CardIcon color='primary'>
            <GiClothes />
          </CardIcon>
          <p className={classes.cardCategory}>Producto</p>
          <h4 className={classes.cardTitle}>{encabezadoStock?.cantidad} en stock</h4>
          <h4 className={classes.cardTitle}>${(encabezadoStock?.total || 0).toFixed(2)}</h4>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='danger' stats icon>
          <CardIcon color='danger'>
            <TbMoneybag />
          </CardIcon>
          <p className={classes.cardCategory}>Saldo</p>
           <h4 className={classes.cardTitle}>Credito ${(saldoCredito || 0).toFixed(2)}</h4>
          <h4 className={classes.cardTitle}>Nota credito ${(saldoNotaCredito || 0).toFixed(2)}</h4>
         <h4 className={classes.cardTitle}>Efectivo ${(saldoEfectivo || 0).toFixed(2)}</h4>
          
        </CardHeader>
      </Card>
    </EncabezadoContainer>
  );
}

EncabezadoCuentaCorriente.propTypes = {
  accountData: PropTypes.object,
  userSelection: PropTypes.object,
};
